import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { EmployeeFormComponent as EpEmployeeFormComponent } from '@ep/shared';
import { EmployeeFormService } from '@app/areas/merchants/services/employee-form.service';
import {
  EmployeeAccessTypeOption,
  EmployeeAccessTypeOptions,
} from '@app/areas/merchants/utils/employee-access-type-options';

@Component({
  selector: 'app-employee-form',
  templateUrl: './employee-form.component.html',
  standalone: true,
  imports: [EpEmployeeFormComponent, AsyncPipe],
})
export class EmployeeFormComponent {
  private readonly employeeFormService = inject(EmployeeFormService);

  protected employeeForm = this.employeeFormService.getForm();
  protected mode$ = this.employeeFormService.mode$;

  protected accessTypeOptions: EmployeeAccessTypeOption[] = EmployeeAccessTypeOptions;

  protected addPin(): void {
    this.employeeFormService.addTerminalPin();
  }

  protected removePin(): void {
    this.employeeFormService.removeTerminalPin();
  }
}
